import React from "react";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";
import HighCharts from "../../utils/charts/HighCharts";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import InfoIcon from "../../../assets/Info_Icon.svg";
import { simpleKFormatterOnly } from "../../../redux/constants";

const TicketsSummaryCard = ({ TicketSummarywidget }) => {
  const chart__styles = {
    with: "100%",
    height: "350px",
  };
  const chart__styles1 = {
    with: "100%",
    height: "502px",
  };
  const authParams = useSelector((state) => state.Authentication.authParams);

  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? "D " : "D ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  };

  return (
    <>
      {TicketSummarywidget?.map((e, i) => {
        if (
          e?.widget_id === "tickets_agent-activity_2" ||
          e?.widget_id === "tickets_agent-activity_3" ||
          e?.widget_id === "tickets_agent-activity_4"
        ) {
          return (
            <div className="col-12 col-md-4 pr-0">
              <div className="portlet1 p-0 h-100">
                <div className="border-bottom border-color p-15">
                  <div className="portlet__title fontSize-16 font-weight500 w-100">
                    {e?.widget_id === "tickets_agent-activity_2" &&
                      (e?.widget_name || "Closed Tickets Summary")}
                    {e?.widget_id === "tickets_agent-activity_3" &&
                      (e?.widget_name || "FLR Summary")}
                    {e?.widget_id === "tickets_agent-activity_4" &&
                      (e?.widget_name || "Pending Tickets Summary")}
                  </div>
                  <div
                    className="text_regular-gray fontSize-12 line-height-normal"
                    style={{ height: "4.6rem" }}
                  >
                    {e?.widget_id === "tickets_agent-activity_2" && (
                      <sapn>
                        {e?.widget_description ||
                          "The stats below gives a summary of tickets closed from the agent's end and their average activity with respect to expected activity."}
                      </sapn>
                    )}
                    {e?.widget_id === "tickets_agent-activity_3" &&
                      (e?.widget_description ||
                        "The stats below gives a summary of average first response for tickets with respect to expected FLR time.")}
                    {e?.widget_id === "tickets_agent-activity_4" &&
                      (e?.widget_description ||
                        "The stats below gives a summary and distribution of tickets pending to be resolved.")}
                  </div>
                </div>
                {e?.graphData ? (
                  <div className="d-flex flex-wrap text-center border-left border-color">
                    {e?.graphData?.number_data?.length > 0 ? (
                      e?.graphData?.number_data?.map((el, i) => {
                        return (
                          <div
                            className="border-right border-bottom border-color p-4"
                            style={{ flex: "1 0 calc(50% - 1.5rem)" }}
                          >
                            <div className="wm-chart-card-title line-height-normal mb-15">
                              {el?.text}
                              <Tooltip
                                placement="bottom"
                                title={
                                  el?.text === "Closed Tickets"
                                    ? "These are the tickets closed at the agents' end but the ticket status might not be actually closed."
                                    : el?.text === "AVG Closure TAT"
                                    ? "This is the average time of closing tickets by agents."
                                    : el?.text === "Expected TAT"
                                    ? "This is the time an agent is expected to close assigned tickets."
                                    : el?.text === "FLR Tickets"
                                    ? "This gives the number of tickets for which a first response has been sent."
                                    : el?.text === "AVG FLR TAT"
                                    ? "This is the average time an agent takes to send the first response for assigned tickets."
                                    : el?.text === "Expected TAT"
                                    ? "This is the time an agent is expected to close assigned tickets."
                                    : el?.text === "Pending Tickets" &&
                                      "These are the total number of tickets that are still open at the agent's end"
                                }
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Info Icon"
                                  className="ml-1 cursor-pointer"
                                />
                                {/* <i className="fa fa-question-circle ml-1" /> */}
                              </Tooltip>
                            </div>
                            <div className="wm-chart-card-value">
                              {el?.value
                                ? i === 0
                                  ? simpleKFormatterOnly(el?.value)
                                  : secondsToDhms(el?.value)
                                  ? secondsToDhms(el?.value)
                                  : el?.value
                                : "0"}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div
                        className="portlet_images text-center d-flex align-items-center justify-content-center w-100"
                        style={{ minHeight: "35rem" }}
                      >
                        <div className="">
                          <img
                            alt="no data"
                            src={somethingWentWrong}
                            style={{ maxWidth: "100%", minWidth: "17rem" }}
                          />
                          <p className="mt-15 text_regular-gray">
                            No Data Found
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className={`bg__white  mb-15 d-flex align-items-center justify-content-center text-center pt-4 mt-15 `}
                    style={{
                      height: "calc(100vh - 15.2rem)",
                    }}
                  >
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                )}
                {e?.graphData?.graph_type === "bar-number" && (
                  <div className="portlet__body">
                    {e?.graphData?.data &&
                    e?.graphData?.data !== "No Data Found" ? (
                      <>
                        {e?.widget_id === "tickets_agent-activity_2" &&
                          !e?.graphData?.stacked && (
                            <HighCharts
                              single={e?.graphData?.data}
                              style={chart__styles}
                              xaxis={e?.graphData?.x_label}
                              yaxis={e?.graphData?.y_label}
                              type="bar"
                              id={`${e?.widget_id.toString()}}`}
                              stacked={false}
                              chartGlobalDataLabel={true}
                              agentActivit={true}
                            />
                          )}
                        {e?.widget_id === "tickets_agent-activity_3" &&
                          !e?.graphData?.stacked && (
                            <HighCharts
                              single={e?.graphData?.data}
                              style={chart__styles}
                              xaxis={e?.graphData?.x_label}
                              yaxis={e?.graphData?.y_label}
                              type="bar"
                              chartGlobalDataLabel={true}
                              id={`${e?.widget_id.toString()}}`}
                              stacked={false}
                              agentActivit={true}
                            />
                          )}

                        {e?.widget_id === "tickets_agent-activity_4" &&
                          e?.graphData?.stacked && (
                            <HighCharts
                              single={e?.graphData?.data}
                              style={chart__styles1}
                              xaxis={e?.graphData?.x_label}
                              yaxis={e?.graphData?.y_label}
                              type="bar"
                              id={`${e?.widget_id.toString()}}`}
                              stacked={true}
                            />
                          )}
                      </>
                    ) : (
                      <div
                        className="portlet_images text-center d-flex align-items-center justify-content-center w-100"
                        style={{ minHeight: "35rem" }}
                      >
                        <div className="">
                          <img
                            alt="no data"
                            src={somethingWentWrong}
                            style={{ maxWidth: "100%", minWidth: "17rem" }}
                          />
                          <p className="mt-15 text_regular-gray">
                            No Data Found
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default TicketsSummaryCard;
